module.exports = __webpack_public_path__ + "7a07ef1254a423f85a329e625b0b7f34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppfPreview/day_45.jpg
// module id = 1679
// module chunks = 5